'use strict';

var mergeAll = require('./mergeAll');

function defaults(target, sources, opts) {
  opts = opts || {};
  opts.resolve = opts.resolve || false;
  return mergeAll(target, sources, opts);
}

module.exports = defaults;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/internal/defaults.js
// module id = 782
// module chunks = 0